module.exports = __webpack_public_path__ + "img/add-bg.0be80933.png";